import { useState, useEffect } from "react";
import { Button } from "antd";
import { MdLink } from "react-icons/md";
import { returnDayOrDays } from "./utils";
import { TableRow } from "../../interfaces/TableRow";

import useModal from "../../hooks/useModal";
import {
  CustomModal,
  Header,
  OperationDetail,
  OperationItem,
  OperationList,
  OperationMeta,
  OperationName,
  OperationSeqBadge,
  Title,
  ContainerFooter,
  ButtonRemove
} from "./styles";
import { useTableForm } from "../../hooks/useTableForm";

interface Props {
  form: any
}

function ModalVinculo({ form }: Props) {
  const [itemSelected, setItemSelected] = useState<TableRow | null>(null);
  const {
    setIsVinculo,
    isVinculo,
    setVinculoSequencia,
    vinculoIndex,
    vinculoSequencia
  } = useModal();

  const formTable = useTableForm();
  const { rows, updateRow } = formTable;

  function handleClose(activeSubmit: boolean = false) {
 
    if (!(parseInt(rows[vinculoIndex].vinculo.replace(/\D/g, ""), 10) === itemSelected?.sequencia)) {
      const data = form.getFieldsValue();
      const itens = form.getFieldValue('itens');

      if (itemSelected && activeSubmit) {
        updateRow(vinculoIndex, { vinculo: `Operação ${itemSelected?.sequencia}`, vinculoId: itemSelected?.planoOperacionalOperacaoId });
      } else {
          itens.forEach((item: TableRow, index: number) => {
          if (index === vinculoIndex)
            itens[vinculoIndex] = { 
              ...item,
              vinculo: "", referencia: ""
            }
        });
        form.setFieldsValue({
          ...data,
          itens
        });
        updateRow(vinculoIndex, { vinculo: '', vinculoId: '', referencia: '' });
  
      }

    }

    setVinculoSequencia(-1);
    setItemSelected(null);
    // setSubmitActive(false);
    setIsVinculo(false);
  }

  useEffect(() => {
    if (vinculoSequencia !== -1) {
      const item = rows.find((item: TableRow) => item.sequencia === vinculoSequencia);
      if (item) {
        setItemSelected(item);
      }
    }
  }, [vinculoSequencia]);


  function handleRemoveItem() {
    const data = form.getFieldsValue();
    const itens = form.getFieldValue('itens');
    itens.forEach((item: TableRow, index: number) => {
      if (index === vinculoIndex)
        itens[vinculoIndex] = { 
          ...item,
          vinculo: "", referencia: ""
        }
    })
    updateRow(vinculoIndex, { vinculo: "", referencia: "" });
    form.setFieldsValue({
      ...data,
      itens
     });
    handleClose(false);
  }

  function handleSubmit() {
    handleClose(true);
  }
  const filterAndUnificateRow = () => {
    const rowsFiltered = rows.filter((_, index: number) => index < vinculoIndex);
    return Array.from(
      new Map(
        rowsFiltered.map(item => [item.sequencia, item])
      ).values()).filter((_, index: number) => index < vinculoIndex)
  }

  const handleDeepEqual = (a: any, b: any | null) => {
    if (!a || !b) return false;

    const res =  a.sequencia === b.sequencia && a.operacao.value === b.operacao.value && a.referencia === b.referencia && a.carencia === b.carencia;
    return res;
  }

  return (
    <CustomModal
      title={
        <Header>
          <MdLink size={28} />
          Selecionar Operação Vinculada
        </Header>
      }
      visible={isVinculo}
      width={560}
      onCancel={() => handleClose(false)}
      maskClosable={false}
      centered
      getContainer={document.body}
      footer={
        <ContainerFooter>
          <div>
            <ButtonRemove
              size="large"
              onClick={handleRemoveItem}
              type="default"
            >Remover Vinculo</ButtonRemove>
          </div>
          <div>
            <Button
              size="large"
              onClick={() => handleClose(false)}
              style={{ borderRadius: 8 }}
            >Cancelar
            </Button>
            <Button
              size="large"
              type="primary"
              style={{ backgroundColor: "#12619C", borderRadius: 8, display: "flex", alignItems: "center", gap: 8, float: "right" }}
              onClick={handleSubmit}
            > Confirmar</Button>
          </div>
        </ContainerFooter>
      }
    >
      <Title>
        Selecione a operação à qual esta operação deve estar vinculada.
      </Title>
      <OperationList>
        {filterAndUnificateRow()?.map((item: any) => (
          <OperationItem key={item.id} onClick={() => setItemSelected(item)} isSelected={handleDeepEqual(item, itemSelected)}>
            <OperationSeqBadge isSelected={handleDeepEqual(item, itemSelected)}>{item.sequencia}</OperationSeqBadge>
            <OperationDetail>
              <OperationName>{item.operacao?.text ?? ' - '}</OperationName>
              <OperationMeta>Carência: {returnDayOrDays(item.carencia ?? 0)}</OperationMeta>
            </OperationDetail>
          </OperationItem>
        ))}
      </OperationList>
    </CustomModal>
  );
}

export default ModalVinculo;
